const examplesItems = {
  photo: [
    {
      originalUrl: "/examples/picture/girl1/original.jpg",
      result: [
        { imgUrl: "/examples/picture/girl1/result.jpg", name: "superhero" },
        { imgUrl: "/examples/picture/girl1/anime.jpg", name: "Anime" },
        { imgUrl: "/examples/picture/girl1/gta3.jpg", name: "GTA 3" },
        { imgUrl: "/examples/picture/girl1/gta5.jpg", name: "GTA 5" },
        { imgUrl: "/examples/picture/girl1/cyborg.jpg", name: "cyborg" },
        { imgUrl: "/examples/picture/girl1/barbie.jpg", name: "Barbie" },
        { imgUrl: "/examples/picture/girl1/pop-art.jpg", name: "pop_art" },
        { imgUrl: "/examples/picture/girl1/pin-up.jpg", name: "pin_up" },
      ]
    },
    {
      originalUrl: "/examples/picture/man1/man1-original.jpg",
      result: [
        { imgUrl: "/examples/picture/man1/man1-superhero.jpg", name: "superhero" },
        { imgUrl: "/examples/picture/man1/man1-anime.jpg", name: "Anime" },
        { imgUrl: "/examples/picture/man1/man1-gta3.jpg", name: "GTA 3" },
        { imgUrl: "/examples/picture/man1/man1-gta5.jpg", name: "GTA 5" },
        { imgUrl: "/examples/picture/man1/man1-cyborg.jpg", name: "cyborg" },
        { imgUrl: "/examples/picture/man1/man1-barbie.jpg", name: "Barbie" },
        { imgUrl: "/examples/picture/man1/man1-pop-art.jpg", name: "pop_art" },
        { imgUrl: "/examples/picture/man1/man1-pin-up.jpg", name: "pin_up" },
      ]
    },
    {
      originalUrl: "/examples/picture/girl2/original.jpg",
      result: [
        { imgUrl: "/examples/picture/girl2/girl2-superhero.jpg", name: "superhero" },
        { imgUrl: "/examples/picture/girl2/girl2-anime.jpg", name: "Anime" },
        { imgUrl: "/examples/picture/girl2/girl2-gta3.jpg", name: "GTA 3" },
        { imgUrl: "/examples/picture/girl2/girl2-gta5.jpg", name: "GTA 5" },
        { imgUrl: "/examples/picture/girl2/girl2-cyborg.jpg", name: "cyborg" },
        { imgUrl: "/examples/picture/girl2/girl2-barbie.jpg", name: "Barbie" },
        { imgUrl: "/examples/picture/girl2/girl2-pop-art.jpg", name: "pop_art" },
        { imgUrl: "/examples/picture/girl2/girl2-pin-up.jpg", name: "pin_up" },
      ]
    },
    {
      originalUrl: "/examples/picture/man2/man2-original.jpg",
      result: [
        { imgUrl: "/examples/picture/man2/man2-superhero.jpg", name: "superhero" },
        { imgUrl: "/examples/picture/man2/man2-anime.jpg", name: "Anime" },
        { imgUrl: "/examples/picture/man2/man2-gta3.jpg", name: "GTA 3" },
        { imgUrl: "/examples/picture/man2/man2-gta5.jpg", name: "GTA 5" },
        { imgUrl: "/examples/picture/man2/man2-cyborg.jpg", name: "cyborg" },
        { imgUrl: "/examples/picture/man2/man2-barbie.jpg", name: "Barbie" },
        { imgUrl: "/examples/picture/man2/man2-pop-art.jpg", name: "pop_art" },
        { imgUrl: "/examples/picture/man2/man2-pin-up.jpg", name: "pin_up" },
      ]
    },
    {
      originalUrl: "/examples/picture/bicycle/original.jpg",
      result: [
        { imgUrl: "/examples/picture/bicycle/watercolour.jpg", name: "Watercolour" },
        { imgUrl: "/examples/picture/bicycle/picasso.jpg", name: "picasso" },
        { imgUrl: "/examples/picture/bicycle/pencil-sketch.jpg", name: "Sketch" },
        { imgUrl: "/examples/picture/bicycle/minecraft.jpg", name: "minecraft" },
        { imgUrl: "/examples/picture/bicycle/future-city.jpg", name: "future_city" },
        { imgUrl: "/examples/picture/bicycle/sci-fi.jpg", name: "sci_fi" },
        { imgUrl: "/examples/picture/bicycle/van-gogh.jpg", name: "van_gogh" },
      ]
    },
    {
      originalUrl: "/examples/picture/waterfall/waterfall-original.jpg",
      result: [
        { imgUrl: "/examples/picture/waterfall/waterfall-watercolour.jpg", name: "Watercolour" },
        { imgUrl: "/examples/picture/waterfall/waterfall-picasso.jpg", name: "picasso" },
        { imgUrl: "/examples/picture/waterfall/waterfall-pencil-sketch.jpg", name: "Sketch" },
        { imgUrl: "/examples/picture/waterfall/waterfall-minecraft.jpg", name: "minecraft" },
        { imgUrl: "/examples/picture/waterfall/waterfall-future-city.jpg", name: "future_city" },
        { imgUrl: "/examples/picture/waterfall/waterfall-sci-fi.jpg", name: "sci_fi" },
        { imgUrl: "/examples/picture/waterfall/waterfall-van-gogh.jpg", name: "van_gogh" },
      ]
    },
    {
      originalUrl: "/examples/picture/city/city-original.jpg",
      result: [
        { imgUrl: "/examples/picture/city/city-watercolour.jpg", name: "Watercolour" },
        { imgUrl: "/examples/picture/city/city-picasso.jpg", name: "picasso" },
        { imgUrl: "/examples/picture/city/city-pencil-sketch.jpg", name: "Sketch" },
        { imgUrl: "/examples/picture/city/city-minecraft.jpg", name: "minecraft" },
        { imgUrl: "/examples/picture/city/city-future-city.jpg", name: "future_city" },
        { imgUrl: "/examples/picture/city/city-sci-fi.jpg", name: "sci_fi" },
        { imgUrl: "/examples/picture/city/city-van-gogh.jpg", name: "van_gogh" },
      ]
    },
    {
      originalUrl: "/examples/picture/town/town-original.jpg",
      result: [
        { imgUrl: "/examples/picture/town/town-watercolour.jpg", name: "Watercolour" },
        { imgUrl: "/examples/picture/town/town-picasso.jpg", name: "picasso" },
        { imgUrl: "/examples/picture/town/town-pencil.jpg", name: "Sketch" },
        { imgUrl: "/examples/picture/town/town-minecraft.jpg", name: "minecraft" },
        { imgUrl: "/examples/picture/town/town-future-city.jpg", name: "future_city" },
        { imgUrl: "/examples/picture/town/town-sci-fi.jpg", name: "sci_fi" },
        { imgUrl: "/examples/picture/town/town-van-gogh.jpg", name: "van_gogh" },
      ]
    }
  ],
  interior: [
    {
      originalUrl: "/examples/interior/kitchen1/kitchen1-original-preview.jpg",
      result: [
        { imgUrl: "/examples/interior/kitchen1/kitchen1-original.jpg", name: "Original" },
        { imgUrl: "/examples/interior/kitchen1/kitchen1-scandinavian.jpg", name: "scandinavian" },
        { imgUrl: "/examples/interior/kitchen1/kitchen1-minimalist.jpg", name: "minimalist" },
        { imgUrl: "/examples/interior/kitchen1/kitchen1-loft.jpg", name: "loft" },
        { imgUrl: "/examples/interior/kitchen1/kitchen1-modern.jpg", name: "modern" },
        { imgUrl: "/examples/interior/kitchen1/kitchen1-barbie1.jpg", name: "Barbie 1" },
        // { imgUrl: "/examples/interior/kitchen1/kitchen1-barbie2.jpg", name: "Barbie 2" },
      ]
    },
    {
      originalUrl: "/examples/interior/kitchen2/kitchen2-original-preview.jpg",
      result: [
        { imgUrl: "/examples/interior/kitchen2/kitchen2-original.jpg", name: "Original" },
        { imgUrl: "/examples/interior/kitchen2/kitchen2-scandinavian.jpg", name: "scandinavian" },
        { imgUrl: "/examples/interior/kitchen2/kitchen2-minimalist.jpg", name: "minimalist" },
        { imgUrl: "/examples/interior/kitchen2/kitchen2-loft.jpg", name: "loft" },
        { imgUrl: "/examples/interior/kitchen2/kitchen2-modern.jpg", name: "modern" },
        { imgUrl: "/examples/interior/kitchen2/kitchen2-barbie1.jpg", name: "Barbie 1" },
        // { imgUrl: "/examples/interior/kitchen2/kitchen2-barbie2.jpg", name: "Barbie 2" },
      ]
    },
    {
      originalUrl: "/examples/interior/living-room1/living-room1-original-preview.jpg",
      result: [
        { imgUrl: "/examples/interior/living-room1/living-room1-original.jpg", name: "Original" },
        { imgUrl: "/examples/interior/living-room1/living-roon1-scandinavian.jpg", name: "scandinavian" },
        { imgUrl: "/examples/interior/living-room1/living-room1-minimalist.jpg", name: "minimalist" },
        { imgUrl: "/examples/interior/living-room1/living-room1-loft.jpg", name: "loft" },
        { imgUrl: "/examples/interior/living-room1/living-room1-modern.jpg", name: "modern" },
        { imgUrl: "/examples/interior/living-room1/living-room1-barbie1.jpg", name: "Barbie 1" },
        // { imgUrl: "/examples/interior/living-room1/living-room1-barbie2.jpg", name: "Barbie 2" },
      ]
    },
    {
      originalUrl: "/examples/interior/living-room2/living-room2-original-preview.jpg",
      result: [
        { imgUrl: "/examples/interior/living-room2/living-room2-original.jpg", name: "Original" },
        { imgUrl: "/examples/interior/living-room2/living-room2-scandinavian.jpg", name: "scandinavian" },
        { imgUrl: "/examples/interior/living-room2/living-room2-minimalist.jpg", name: "minimalist" },
        { imgUrl: "/examples/interior/living-room2/living-room2-loft.jpg", name: "loft" },
        { imgUrl: "/examples/interior/living-room2/living-room2-modern.jpg", name: "modern" },
        { imgUrl: "/examples/interior/living-room2/living-room2-barbie1.jpg", name: "Barbie 1" },
        // { imgUrl: "/examples/interior/living-room2/living-room2-barbie2.jpg", name: "Barbie 2" },
      ]
    },
    {
      originalUrl: "/examples/interior/bedroom1/bedroom1-original-preview.jpg",
      result: [
        { imgUrl: "/examples/interior/bedroom1/bedroom1-original.jpg", name: "Original" },
        { imgUrl: "/examples/interior/bedroom1/bedroom1-scandinavian.jpg", name: "scandinavian" },
        { imgUrl: "/examples/interior/bedroom1/bedroom1-minimalist.jpg", name: "minimalist" },
        { imgUrl: "/examples/interior/bedroom1/bedroom1-loft.jpg", name: "loft" },
        { imgUrl: "/examples/interior/bedroom1/bedroom1-modern.jpg", name: "modern" },
        { imgUrl: "/examples/interior/bedroom1/bedroom1-barbie1.jpg", name: "Barbie 1" },
        // { imgUrl: "/examples/interior/bedroom1/bedroom1-barbie2.jpg", name: "Barbie 2" },
      ]
    },
    {
      originalUrl: "/examples/interior/bedroom2/bedroo2-original-preview.jpg",
      result: [
        { imgUrl: "/examples/interior/bedroom2/bedroom2-original.jpg", name: "Original" },
        { imgUrl: "/examples/interior/bedroom2/bedroom2-scandinavian.jpg", name: "scandinavian" },
        { imgUrl: "/examples/interior/bedroom2/bedroom2-minimalist.jpg", name: "minimalist" },
        { imgUrl: "/examples/interior/bedroom2/bedroom2-loft.jpg", name: "loft" },
        { imgUrl: "/examples/interior/bedroom2/bedroom2-modern.jpg", name: "modern" },
        { imgUrl: "/examples/interior/bedroom2/bedroom2-barbie1.jpg", name: "Barbie 1" },
        // { imgUrl: "/examples/interior/bedroom2/bedroom2-barbie2.jpg", name: "Barbie 2" },
      ]
    }
  ],
  text: [
    {
      prompt: "promt_text2image_robot",
      promptText: "Robot helper cooking dinner in a modern kitchen interior, with vegetables",
      result: [
        { imgUrl: "/examples/text/robot/robot-realism.jpg", name: "realistic" },
        { imgUrl: "/examples/text/robot/robot-anime.jpg", name: "Anime" },
        { imgUrl: "/examples/text/robot/robot-watercolor.jpg", name: "Watercolour" },
        { imgUrl: "/examples/text/robot/robot-minimalist.jpg", name: "minimalist" },
        { imgUrl: "/examples/text/robot/robot-cartoon.jpg", name: "Cartoon" },
        { imgUrl: "/examples/text/robot/robot-sci-fi.jpg", name: "sci_fi" },
        { imgUrl: "/examples/text/robot/robot-oil-painting.jpg", name: "Oil Painting" },
        { imgUrl: "/examples/text/robot/robot-pencil.jpg", name: "Sketch" },
      ]
    },
    {
      prompt: "promt_text2image_woman",
      promptText: "Stunning young woman with flowing hair, wearing a floral dress",
      result: [
        { imgUrl: "/examples/text/young-woman/realistic.jpg", name: "realistic" },
        { imgUrl: "/examples/text/young-woman/anime.jpg", name: "Anime" },
        { imgUrl: "/examples/text/young-woman/watercolor.jpg", name: "Watercolour" },
        { imgUrl: "/examples/text/young-woman/minimalist.jpg", name: "minimalist" },
        { imgUrl: "/examples/text/young-woman/cartoon.jpg", name: "Cartoon" },
        { imgUrl: "/examples/text/young-woman/sci-fi.jpg", name: "sci_fi" },
        { imgUrl: "/examples/text/young-woman/oil-painting.jpg", name: "Oil Painting" },
        { imgUrl: "/examples/text/young-woman/pencil.jpg", name: "Sketch" },
      ]
    },
    {
      prompt: "promt_text2image_knight",
      promptText: "The image of a knight in shining armour, riding a white horse",
      result: [
        { imgUrl: "/examples/text/knight/knight realistic.jpg", name: "realistic" },
        { imgUrl: "/examples/text/knight/knight anime.jpg", name: "Anime" },
        { imgUrl: "/examples/text/knight/knight watercolor.jpg", name: "Watercolour" },
        { imgUrl: "/examples/text/knight/knight minimalist.jpg", name: "minimalist" },
        { imgUrl: "/examples/text/knight/knight cartoon.jpg", name: "Cartoon" },
        { imgUrl: "/examples/text/knight/knight sci fi.jpg", name: "sci_fi" },
        { imgUrl: "/examples/text/knight/knight oil painting.jpg", name: "Oil Painting" },
        { imgUrl: "/examples/text/knight/knight pencil.jpg", name: "Sketch" },
      ]
    },
    {
      prompt: "promt_text2image_town",
      promptText: "Old town with narrow streets, cobbled stones",
      result: [
        { imgUrl: "/examples/text/old-town/old town realistic.jpg", name: "realistic" },
        { imgUrl: "/examples/text/old-town/old town anime.jpg", name: "Anime" },
        { imgUrl: "/examples/text/old-town/old town watercolor.jpg", name: "Watercolour" },
        { imgUrl: "/examples/text/old-town/old town - minimalist.jpg", name: "minimalist" },
        { imgUrl: "/examples/text/old-town/old town cartoon.jpg", name: "Cartoon" },
        { imgUrl: "/examples/text/old-town/old town sci fi.jpg", name: "sci_fi" },
        { imgUrl: "/examples/text/old-town/old town oil painting.jpg", name: "Oil Painting" },
        { imgUrl: "/examples/text/old-town/old town sketch.jpg", name: "Sketch" },
      ]
    },
    {
      prompt: "promt_text2image_alien",
      promptText: "Alien landscape with unusual plants",
      result: [
        { imgUrl: "/examples/text/alien-landscape/alien landscape realistic.jpg", name: "realistic" },
        { imgUrl: "/examples/text/alien-landscape/alien landscape anime.jpg", name: "Anime" },
        { imgUrl: "/examples/text/alien-landscape/alien landscape watercolor.jpg", name: "Watercolour" },
        { imgUrl: "/examples/text/alien-landscape/alien landscape minimalist.jpg", name: "minimalist" },
        { imgUrl: "/examples/text/alien-landscape/alien landscape cartoon.jpg", name: "Cartoon" },
        { imgUrl: "/examples/text/alien-landscape/alien landscape sci fi.jpg", name: "sci_fi" },
        { imgUrl: "/examples/text/alien-landscape/alien landscape oil painting.jpg", name: "Oil Painting" },
        { imgUrl: "/examples/text/alien-landscape/alien landscape pencil sketch.jpg", name: "Sketch" },
      ]
    },
    {
      prompt: "promt_text2image_puppy",
      promptText: "Cute puppy playing in the park with brightly coloured toys",
      result: [
        { imgUrl: "/examples/text/cute-puppy/puppy realistic.jpg", name: "realistic" },
        { imgUrl: "/examples/text/cute-puppy/puppy anime .jpg", name: "Anime" },
        { imgUrl: "/examples/text/cute-puppy/puppy watercolor.jpg", name: "Watercolour" },
        { imgUrl: "/examples/text/cute-puppy/puppy minimalism.jpg", name: "minimalist" },
        { imgUrl: "/examples/text/cute-puppy/puppy cartoon.jpg", name: "Cartoon" },
        { imgUrl: "/examples/text/cute-puppy/puppy sci fi.jpg", name: "sci_fi" },
        { imgUrl: "/examples/text/cute-puppy/puppy oil painting.jpg", name: "Oil Painting" },
        { imgUrl: "/examples/text/cute-puppy/puppy pencil sketch.jpg", name: "Sketch" },
      ]
    }

  ]
}

export { examplesItems }